// router.ts

import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import AboutView from "../views/AboutView.vue";
import LoginView from "../views/LoginView.vue";
import ManagementView from "../views/ManagementView.vue";
import { getCurrentUser } from "../auth";
import { getCurrentBrand, hasAccessToBrand } from "@/brandService";
import { loadBrandConfigs, isBrandConfigLoaded } from "@/services/brandConfigService";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "LoginView",
    component: LoginView,
  },
  {
    path: "/about",
    name: "about",
    component: AboutView,
    meta: { requiresAuth: true },
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: HomeView,
    meta: { requiresAuth: true },
  },
  {
    path: "/management",
    name: "management",
    component: ManagementView,
    meta: { requiresAuth: true, requiresBrand: 'jogoglobal-admin' },
  },
  {
    path: "*",
    redirect: "/dashboard",
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((route) => route.meta.requiresAuth)) {
    const isAuthenticated = !!getCurrentUser();
    if (!isAuthenticated) {
      next("/login");
      return;
    }
    try {
      if (!hasAccessToBrand(getCurrentBrand())) {
        next("/login");
        return;
      }
    } catch {
      next("/login");
      return;
    }
    try {
      const brand = getCurrentBrand();
      if (!isBrandConfigLoaded(brand)) {
        await loadBrandConfigs();
      }
    } catch (e) {
      console.error('Failed to load brand configs', e);
    }
    const requiresBrand = to.meta?.requiresBrand as string | undefined;
    if (requiresBrand) {
      const userBrand = getCurrentBrand();
      if (userBrand !== requiresBrand) {
        next("/dashboard");
        return;
      }
    }
    next();
  } else {
    next();
  }
});

export default router;
